import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import isValid from '../node_modules/date-fns/esm/isValid/index.js';

// 작성시는 Date사용, 저장할때는 string으로 적혀있기 때문에 변환 필요
function convertDurationFormat(duration) {
  if (!duration) {
    return;
  }
  var _duration$startAt = duration.startAt,
    startAt = _duration$startAt === void 0 ? '' : _duration$startAt,
    _duration$endAt = duration.endAt,
    endAt = _duration$endAt === void 0 ? '' : _duration$endAt;
  var start = isValid(new Date(startAt)) ? new Date(startAt) : undefined;
  var end = isValid(new Date(endAt)) ? new Date(endAt) : undefined;
  return _objectSpread2(_objectSpread2({}, start && {
    startAt: start
  }), end && {
    endAt: end
  });
}
function convertRemainTime() {
  var timestamp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var timeGap = new Date(0, 0, 0, 0, 0, 0, timestamp);
  return {
    days: Math.floor(timestamp / (1000 * 60 * 60 * 24)),
    // 일
    hours: timeGap.getHours(),
    // 시
    minutes: timeGap.getMinutes(),
    // 분
    seconds: timeGap.getSeconds() // 초
  };
}

export { convertDurationFormat, convertRemainTime };
//# sourceMappingURL=duration.js.map
